export const getters = {
    list: state => state.list,
    services: state => state.services,
    statistics: state => state.statistics,
    inventory: state => state.inventory,
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
};
